import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSidenavModule } from '@angular/material/sidenav';
import { Routes } from '@angular/router';
import { NgxMaskModule } from 'ngx-mask';
import { AuthState } from '../auth/model/auth-state';
import { SharedModule } from '../shared/shared.module';
import { SkeletonComponent } from '../shared/skeleton/skeleton.component';
import { ContactService } from './contact.service';
import { CallFiltersComponent } from './dashboard/call-filters/call-filters.component';
import { CancelButtonComponent } from './dashboard/cancel-button/cancel-button.component';
import { DashboardSectionHeaderComponent } from './dashboard/dashboard-section-header/dashboard-section-header.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ListComponent } from './dashboard/list-component/list.component';
import { PatientContactElementComponent } from './dashboard/patient-contact-element/patient-contact-element.component';
import { TabHeaderComponent } from './dashboard/tab-header/tab-header.component';
import { AlertStatusLegendComponent } from './alert-status-legend/alert-status-legend.component';
import { MessageBodyDialogComponent } from './dashboard/message-body-dialog/message-body-dialog.component';
import { OrganizationsComponent } from '../contacts/organizations/organizations.component';
import { FhirGuardService } from './fhir-guard.service';
import { NotificationService } from './notification.service';
import { NotificationViewModel } from './notification.view-model';

export const notificationRoutes: Routes = [
  {
    path: AuthState.AUTHORIZED,
    component: DashboardComponent,
    canActivate: [FhirGuardService],
  },
];

@NgModule({
  declarations: [
    DashboardComponent,
    PatientContactElementComponent,
    CancelButtonComponent,
    ListComponent,
    CallFiltersComponent,
    TabHeaderComponent,
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    MatSidenavModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatCardModule,
    MatNativeDateModule,
    DashboardSectionHeaderComponent,
    MessageBodyDialogComponent,
    AlertStatusLegendComponent,
    OrganizationsComponent,
    NgxMaskModule.forRoot(),
    SkeletonComponent,
  ],
  providers: [
    NotificationViewModel,
    NotificationService,
    ContactService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class NotificationModule {}
